import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useHref } from 'react-router-dom';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TextField, Button, Typography, Grid, FormControl, FormControlLabel, Switch } from '@mui/material';
import { useCreateOrganizationUserMutation, useGetOrganizationUserQuery } from '../features/api/rest/apiOrganizationsSlice';
import { setAlertMessage } from '../features/layoutSlice';

function EditUserOrganization() {
  const { opk } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setemail] = useState('');
  const [isAdmin, setIsadmin] = useState(false);
  const [adduser] = useCreateOrganizationUserMutation();
  const { data: users = [] } = useGetOrganizationUserQuery(opk);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const backtoorg = () => {
    navigate(`/profile/organizations/${opk}/users`);
  };
  const dispatch = useDispatch();

  const baseUrl = new URL(window.location.href);
  baseUrl.search = '';
  const hrefuserorganization = useHref('/profile/organizations/{org_id}/users', { relative: false });
  const urlnotification = new URL(hrefuserorganization, baseUrl).href;

  const hrefsignuporganization = useHref(`/signuporganization/${opk}/{user_id}/{token}`, { relative: false });
  const urlinvitation = new URL(hrefsignuporganization, baseUrl).href;
  const handleSubmit = () => {
    if (email === '') return dispatch(setAlertMessage({ text: t('organizations.user.add_messagge'), type: 'error' }));
    if (emailRegex.test(email) === false) return dispatch(setAlertMessage({ text: t('organizations.user.add_messagge2'), type: 'error' }));
    const checkUserEmail = users.some((user) => user.user_details.email === email);
    if (checkUserEmail) dispatch(setAlertMessage({ text: t('organizations.user.alertadd1'), type: 'error' }));
    if (!checkUserEmail) {
      adduser({
        opk,
        payload: { user_email: email, is_admin: isAdmin },
        invurl: urlinvitation,
        orgurl: urlnotification,
      });
      dispatch(setAlertMessage({ text: t('organizations.user.add_success'), type: 'success' }));
    }
    return null;
  };
  const handleSwitchChange = (event) => {
    const { checked } = event.target;
    setIsadmin(checked);
  };
  return (
    <>
      <Typography variant="h5" paddingBottom="1em">
        {t('organizations.user.add')}
      </Typography>
      <Grid data-testid="AddOrganization" component="form" container onSubmit={handleSubmit} sx={{ display: 'flex', justifyContent: 'column', flexDirection: 'column' }}>
        <Grid sx={{ display: 'flex' }}>
          <Typography sx={{ padding: '1em' }}>{t('organizations.user.user')}</Typography>
          <TextField id="orgname" label="user@mail.com" name="email" value={email} autoComplete={email} inputProps={{ 'user-data': 'email' }} onChange={(e) => setemail(e.target.value)} />
        </Grid>

        <FormControl sx={{ padding: '1em 2.5em 1em 2.5em' }}>
          <FormControlLabel control={<Switch checked={isAdmin} onChange={handleSwitchChange} />} label={t(`organizations.user.admin`)} />
        </FormControl>
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex' }}>
        <Button type="submit" variant="contained" color="primary" sx={{ margin: '5px' }} onClick={handleSubmit}>
          {t('organizations.form.submit')}
        </Button>
      </Grid>
      <Button variant="contained" onClick={backtoorg} sx={{ ml: 1, margin: '3px' }}>
        {t('organizations.backOrganizations')}
      </Button>
    </>
  );
}
export default EditUserOrganization;
